exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".external-contact-form-wrapper{width:400px}", ""]);

// exports
